<template>
  <div>
    <div v-if="isOrgAdmin">
      <identity-providers />
      <router-view />
    </div>
    <empty-page v-else type="permission"></empty-page>
  </div>
</template>

<script>
import IdentityProviders from './IdentityProviders';
import { mapGetters } from 'vuex';
import EmptyPage from '@/shared/components/EmptyPage.vue';

export default {
  components: {
    EmptyPage,
    'identity-providers': IdentityProviders,
  },
  data() {
    return {
      fields: ['name', 'single_sign_on_url', 'options'],
    };
  },
  computed: {
    ...mapGetters({
      isOrgAdmin: 'isOrgAdmin',
    }),
  },
  mounted() {
    if (this.isOrgAdmin) {
      this.$store.dispatch('getIdentityProvider');
    }
  },
};
</script>

<style lang="scss">
.message-card {
  border: 1px $color-almost-black-60 solid;
  border-radius: 2px;
  background: $color-off-white;
  padding: 20px;
}

p {
  margin-bottom: 0rem !important;
}
</style>
